<template>
    <main class="SectionArtworkCard-MAIN hide-scrollbar">
        <section>

            <ProgressImage class="artworkcard-image" v-if="artworkData?.file"
                :thumbSrc="`${this.$ENDPOINT}/assets/thumbnails_artworks/${artworkData.file}`"
                :fullSrc="`${this.$ENDPOINT}/assets/artworks/${artworkData.file}`"
                :alt="`Artwork ${artworkData.titulo}`"
                @click="fullView = true"
            />

            <!--<img v-if="artworkData?.file" :src="`${this.$ENDPOINT}/assets/artworks/${artworkData.file}`" class="artworkcard-image"/>-->
            <div><button @click="openListModal('artwork', artworkData.id)">+</button></div>
            
            <div class="artworkcard-title">
                <p>{{ artworkData.titulo }}</p>
            </div>
            <div class="artworkcard-details">
                <div>
                    <span>ARTISTA</span>
                    <p>{{ artworkData.artist_nombre }} {{ artworkData.artist_apellido }}</p>
                </div>
                <div>
                    <span>MEDIDAS</span>
                    <p>{{ artworkData.medidas_cm?.replaceAll("x", " x ") }}</p>
                </div>
            </div>
            <div>
                <div>
                    <span>TÉCNICA</span>
                    <p>{{ artworkData.tecnica }}</p>
                </div>
            </div>
            <!--<div class="artworkcard-description">
                <span>DESCRIPCIÓN</span>
                <p>{{ artworkData }}</p>
            </div>-->
            <!--<div class="artworkcard-status">
                <div>
                    <span>ESTADO</span>
                    <p>{{ artworkData.estado }}</p>
                </div>
                <div>
                    <span>PRECIO</span>
                    <p>${{ artworkData.precio_mxn }} MXN</p>
                </div>
            </div>-->
            <button @click="moreInfo()" v-if="!fullView">
                MÁS INFO
            </button>

            <button v-else @click="fullView = false">CERRAR</button>

        </section>

        <section class="artworkcard-full" v-if="fullView">
            <button class="close-full-btn" @click="fullView = false">CERRAR</button>
            <PinchScrollZoom
                class="zoom-wrapper"
                :width="windowWidth"
                :height="windowHeight"
                :min-scale="1"
                :max-scale="5"
                :scale="1"
                :wheel="true"
                :double-tap="true"
            >
                <img :src="`${this.$ENDPOINT}/assets/artworks/${artworkData.file}`"/>
            </PinchScrollZoom>
        </section>

        <ListComponent
            :active="listModal.active"
            :item-type="listModal.itemType"
            :item-id="listModal.itemId"
            @close="listModal.active = false"
        />
    </main>
</template>

<script>
import PinchScrollZoom from '@coddicat/vue-pinch-scroll-zoom';
import '@coddicat/vue-pinch-scroll-zoom/style.css';

import ListComponent from '@/components/ListComponent.vue';
import ProgressImage from '@/components/ProgressImage.vue';

export default {
    name: 'SectionArtworkCard',
    components: {
        ProgressImage, ListComponent, PinchScrollZoom,
    },
    props: {
        id: { type: [String, Number], required: true }
    },
    data(){
        return{
            artworkData: {},
            fullView: false,
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            listModal: {
                active: false,
                itemType: '',
                itemId: null
            }
        }
    },
    methods: {
        moreInfo(){
            this.$router.push({ name: 'contact', params: { id: String(this.id) }, query: { from: 'artwork' } });
        },

        async loadArtwork(){
            const response = await fetch(`${this.$ENDPOINT}/api/get_artwork.php?id=${encodeURIComponent(this.id)}`);
            const result = await response.json();
            if(result.status === "success") this.artworkData = result.artwork;
        },

        openListModal(type, id) {
            this.listModal = {
                active: true,
                itemType: type,
                itemId: id
            };
        }
    },
    mounted(){
        this.loadArtwork();
    },
    watch: {
        id(){
            this.loadArtwork();
        }
    }
}
</script>

<style>
.artworkcard-image, .artworkcard-image img{
    width: 75vw;
    aspect-ratio: 1/1;
    margin: 0 auto;
    margin-top: 2ch;
    margin-bottom: 1ch;
    object-fit: contain;
    object-position: center;
}

.artworkcard-image{
    border: none !important;
}
</style>

<style scoped lang="stylus">
.SectionArtworkCard-MAIN
    background-color: white
    height: 100dvh
    overflow-y: auto
    overflow-x: hidden
    position: relative
    box-sizing: border-box
    //padding-bottom: 47px

    >section:first-child
        margin: 2vw
        padding: 2vw
        height: auto
        min-height: 0
        max-height: none
        padding-bottom: calc(47px + 12vw + env(safe-area-inset-bottom))
        box-sizing: border-box
        font-family: "Archivo ExtraCondensed", sans-serif
        display: flex
        flex-direction: column

        .artworkcard-arr-back
            max-width: 6vw
            max-height: 6vw
            position: fixed
            top: 4vw
            left: 4vw
            z-index 1

        >div
            border-bottom: 1px solid #DCDCDC
            padding: 1ch 0
            display: flex
            justify-content: space-between

            p
                margin: 0
                font-size: 2.8ch

            span
                color: #DCDCDC
                font-size: 2.2ch
                font-family: "DM Mono", monospace

        >button
                height: 47px
                width: calc(180px + 18px + 18px)
                background-color: rgb(1, 90, 255)
                border: none
                color: white
                max-width: 75vw
                position: fixed
                margin: auto
                left: 0
                right: 0
                bottom: 6vw
                border-radius: 100vw
                z-index: 1
                font-family: "DM Mono", monospace

.artworkcard-title
    font-size: 3ch

.artworkcard-details
.artworkcard-status
    padding: 2ch 0 !important

    p
        margin-top: 5px !important;

.artworkcard-details > div
    max-width: 45%

.artworkcard-status > div
    max-width: 50%

.artworkcard-description
    display: flex
    flex-direction: column

.artworkcard-full
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100dvh
    background-color: rgba(0, 0, 0, 0.85)
    z-index: 20
    overflow: hidden

.zoom-wrapper
    width: 100vw
    height: 100dvh

    img
        max-width: 100vw
        max-height: 100dvh
        object-fit: contain
        user-select: none
        -webkit-user-drag: none

.close-full-btn
    position: fixed
    left: 0
    right: 0
    bottom: 6vw
    margin: auto
    width: calc(180px + 18px + 18px)
    height: 47px
    max-width: 75vw
    border-radius: 100vw
    border: none
    background-color: rgb(1, 90, 255)
    color: white
    font-family: "DM Mono", monospace
    z-index: 30
</style>
